import { AfterViewInit, Component, ElementRef, inject, OnDestroy, viewChild } from '@angular/core';
import { BottomSheetLevel } from 'src/app/interfaces/mat.interface';
import { MatBottomSheetService } from 'src/app/services/mat-bottom-sheet.service';

@Component({
  selector: 'app-drag-handle',
  standalone: true,
  templateUrl: './drag-handle.component.html',
  styleUrls: ['./drag-handle.component.scss'],
  host: {
    style: `
      position: sticky;
      top: 0;
      z-index: 1000;
      display: block;
      width: 100%;
      height: fit-content;
    `
  }
})
export class DragHandleComponent implements AfterViewInit, OnDestroy {
  public dragHandleRef = viewChild.required<ElementRef>('dragHandleRef');
  
  private _matBottomSheetService = inject(MatBottomSheetService);

  ngAfterViewInit(): void {
    if (!this.dragHandleRef()) return;
    this._matBottomSheetService.bottomSheetCurrentLevel = BottomSheetLevel.EXPANDED;
    this._matBottomSheetService.changeLevelBottomSheetOnSwipeDown(this.dragHandleRef());
  }
  
  ngOnDestroy(): void {
    if (!this.dragHandleRef()) return;
    this._matBottomSheetService.destroyBottomSheetOnSwipeDown(this.dragHandleRef());
  }
}
